module.exports = __webpack_public_path__ + "media/images/proof_links/deezer-16bfcc403c8add4e40f829335465dcae.svg";